<template>
    <div class="content">
        <div class="content-full" :class="{showTips}">
            <div class="content-title sensitive-title">
                {{ $t('敏感词设置') }}
                <div class="global-switch-bar">
                    <v-switch
                        v-model="globalSwitch"
                        :disabled="loading"
                        class="global-switch-bar__switch"
                        @click="setCorpFeatureStatus"
                    />
                    <span class="global-switch-bar__title">{{ globalSwitch ? $t('已开启') : $t('未开启') }}</span>
                </div>
            </div>
            <lamp-tip v-if="showTips" local-key="mng.sensitiveMonitor" class="sensitive-lampTip">
                <div class="lamptip-desc">
                    <span>{{ $t('敏感词的预警配置已迁移至【运营分析-监控预警-预警规则设置】，') }}<a :href="sensitiveLink">{{ $t('立即前往设置') }}</a></span>
                </div>
            </lamp-tip>
            <template v-if="clientSideFlag === 1">
                <v-tabs
                    v-model="tabValue"
                    class="content-tabs"
                    @change="tabChange"
                >
                    <v-tab value="staff">
                        {{ $t('员工敏感行为规则') }}
                    </v-tab>
                    <v-tab value="client">
                        {{ $t('客户敏感行为规则') }}
                    </v-tab>
                </v-tabs>
            </template>
            <template v-else>
                <v-tabs
                    v-model="tabValue"
                    class="content-tabs"
                    @change="tabChange"
                >
                    <v-tab value="sensitiveManage">
                        {{ $t('敏感词管理') }}
                    </v-tab>
                    <v-tab v-if="showMonitorRecords" value="monitorRecords">
                        {{ $t('监控记录') }}
                    </v-tab>
                </v-tabs>
            </template>
            <div class="page-container">
                <div id="login-placeholder" />
                <div id="app" />
                <s
                    v-if="firstLoading"
                    class="loading"
                />
                <div
                    v-else
                    class="page-wrapper"
                >
                    <s
                        v-if="loading"
                        class="loading"
                    />
                    <div
                        v-else
                        class="rule-list__container"
                    >
                        <!-- <div class="rule-list__container"> -->
                        <div
                            v-if="!globalSwitch || data.length == 0"
                            class="rule-welcome"
                        >
                            <div class="rule-welcome__pic" />
                            <div class="rule-welcome__title">
                                {{ globalSwitch ? $t('暂无敏感词') : $t('暂未开启敏感词监控') }}
                            </div>
                            <div class="rule-welcome__slogan">
                                {{ globalSwitch ? $t('创建敏感词规则，有效处理敏感信息，避免业务损失') : $t('自定义敏感词，有效处理敏感信息，避免业务损失') }}
                            </div>
                            <div
                                v-if="globalSwitch"
                                class="rule-welcome__action"
                            >
                                <v-button
                                    status="primary"
                                    size="large"
                                    @click="createRule"
                                >
                                    {{ $t('开始创建') }}
                                </v-button>
                            </div>
                        </div>
                        <div v-else>
                            <template v-if="tabValue !== 'monitorRecords'">
                                <div class="action-bar">
                                <template v-if="clientSideFlag === 1">
                                    <template v-if="tabValue === 'staff'">
                                        <v-button
                                            v-popper:selecList.click
                                            status="primary"
                                        >
                                            <v-icon name="new" /> <span>{{ $t('新建规则') }}</span><v-icon
                                                name="arrow_down_small_line"
                                                fill="#fff"
                                                remote
                                                class="action-bar-right-icon"
                                            />
                                        </v-button>
                                        <v-popper
                                            ref="selecList"
                                            placement="bottom-start"
                                            clazz="action-bar-popper"
                                            inline
                                        >
                                            <v-select-list
                                                v-model="currentSelected"
                                                :options="staffSelectList"
                                                @change="createRule"
                                            />
                                        </v-popper>
                                    </template>
                                    <template v-if="tabValue === 'client'">
                                        <v-button
                                            status="primary"
                                            @click="createRule"
                                        >
                                            <v-icon name="new" /> <span>{{ $t('新建敏感词规则') }}</span>
                                        </v-button>
                                    </template>
                                </template>
                                <template v-else>
                                    <v-button
                                        status="primary"
                                        @click="createRule"
                                    >
                                        <v-icon name="new" /> <span>{{ $t('新建敏感词规则') }}</span>
                                    </v-button>
                                </template>
                            </div>
                            <rule-list
                                :key="ruleListKeys"
                                :loading="pageLoading"
                                :rule-list="data"
                                @operate="operate"
                                @onTagClick="onTagClickHandler"
                            />
                            <v-pagination
                                v-show="pagination.total"
                                :total="pagination.total"
                                :index="pagination.index"
                                :count="pagination.count"
                                class="rule-list__pagination"
                                @change="paginationChange"
                            />
                            </template>
                            <template v-if="tabValue === 'monitorRecords'">
                                <monitor-records-container
                                    :current-sensitive-words="currentSensitiveWords"
                                />
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { Icon } from 'vhtml-ui';
import ruleList from './components/rule-list';
import { getUrlParam } from '@tencent/qd-lib';
import utils from './utils/utils';
import '@/common/global.less';
import LampTip from '@/components/lamp-tip';
import SelectInput from '@/components/select-input/examples/index.vue';
import MonitorRecordsContainer from './components/monitor-records-container/index.vue';
/**
 * 切换菜单假死
 * loading 菜单不能切换
 */

const req = require.context('../../../../../assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'SensitiveMonitor',
    components: {
        ruleList,
        LampTip,
        SelectInput,
        MonitorRecordsContainer
    },
    data() {
        let count = parseInt(window.localStorage.getItem('SENSITIVE_WORDS_PAGE_SIZE'));
        if (count != 15 && count != 30 && count != 50) {
            count = 15;
        }
        let  clientSideFlag  =  0;
        if(window.data.data) {
            clientSideFlag  =  window.data.data.clientSideFlag;
        }
        return {
            firstLoading: true,
            loading: true,
            pageLoading: true,
            data: [],
            pagination: {
                total: 0,
                index: 1,
                count
            },
            globalSwitch: false,
            clientSideFlag:parseInt(clientSideFlag,10), //是否在白名单内白名单内需要展示新页面，不在白名单内 展示老的页面
            tabValue: getUrlParam("currentTab") || (!!+clientSideFlag ? 'staff' : 'sensitiveManage'),
            b2bTabValue: 'sensitiveManage',
            // 本期没有敏感动作 先屏蔽
            // staffSelectList: [ {text: '敏感词规则', value: 'sensitiveWords'}, {text: '敏感动作规则', value: 'sensitiveAction'}],
            staffSelectList: [{ text: this.$t('敏感词规则'), value: 'sensitiveWords' }],
            ruleListKeys:'ru',
            currentSelected:'',
            showTips: false,
            sensitiveLink: '',
            showMonitorRecords: false,
            currentSensitiveWords: ''
        };
    },
    mounted() {
        this.sensitiveLink = `${window.location.protocol}//${window.location.hostname}/cl/monitor/warningSettings`;
        this.getCorpCombos();
        this.getCorpFeatureStatus();
        window.mergerdVersion = 1;
    },
    methods: {
        getCorpCombos(){
            this.$ajax
                .gatewayGet('/v2/combo/corpCombos')
                .then(res => {
                    if (res.code !== 0) {
                        return this.$message.error(this.$t('获取套餐信息失败'));
                    }
                    if (res.data.items.length) {
                        // 获取商通套餐列表
                        const businessComboList = res.data.items.filter(value => +value.type === 2 || +value.type === 5) || [];
                        // 只针对客服套餐展示提醒，商通套餐不展示
                        if (!businessComboList.length) {
                            this.showTips = true;
                        }
                        // 是否商通金融用户, 背景：金融固收行业对信息安全和合规性要求极高，需通过IM工具实现敏感词实时监控、记录追溯及数据管理
                        this.showMonitorRecords = !!(res.data.items.filter(value => +value.sub_type === 1) || []).length;
                    }
                })
                .catch(err => {
                    this.$message.error(err || this.$t('获取套餐信息失败'));
                });
        },
        createRule() {
            let currentType = 1;
            // 去新建页面类型： staffSensitiveWords（员工敏感词，type：1）、staffSensitiveAction（员工敏感动作，type：2）、clientSensitiveWords（客户敏感词，type：3）
            // 对应的map在utils.getCurrentType中
            if(this.clientSideFlag === 1 ) {
                // let currentType = 1;
                if(this.tabValue === "staff") {
                    if (this.currentSelected === "sensitiveWords") {
                        currentType = utils.getCurrentType('staffSensitiveWords') ;
                    }
                    // 敏感动作本期不上先屏蔽
                    // else if(this.currentSelected === "sensitiveAction" ) {
                    //     currentType = utils.getCurrentType('staffSensitiveAction');
                    // }
                } else {
                    currentType = utils.getCurrentType('clientSensitiveWords');
                }
            }
            this.$router.push({
                path: '/tp/sensitiveWords/page',
                query: {
                    currentType,
                }
            });
        },
        operate(type, val, data) {
            if (type == 'status') this.itemStatusChange(val, data);
            else if (type == 'delete') this.delItem(val);
        },
        delItem(delId) {
            let postData = {
                id: delId
            }
            if(this.clientSideFlag === 1 ){
                postData.side = this.tabValue === 'client' ? 2 : 1;
            }
            this.$ajax
                .gatewayPost('/tp/sensitiveWords/deleteSensitiveWordSet', postData)
                .then(
                    data => {
                        const { message = '' } = data;
                        console.log(data);
                        if (data.r == 0) {
                            this.$message(this.$t('删除成功'), 'success');
                            this.paginationChange();
                        } else {
                            this.$message(message ? message : this.$t('删除失败'), 'error');
                        }
                    },
                    error => {
                        console.log(error);
                        this.$message(error || this.$t('请求出错'), 'error');
                    }
                );
        },
        paginationChange(index, count) {
            const current = index || 1;
            this.pageLoading = true;
            let postData = {
                index: current,
                count: count || this.pagination.count,
            }
            // 这里可能还需要判断一下 状态位
            if(this.clientSideFlag === 1) {
                postData.side = this.tabValue === 'client' ? 2 : 1;
            }
            this.$ajax
                .gatewayPost('/tp/sensitiveWords/getList', postData)
                .then(
                    data => {
                        this.pageLoading = false;
                        this.loading = false;
                        const { message = '' } = data;
                        if (data.r == 0) {
                            if (count) {
                                window.localStorage.setItem('SENSITIVE_WORDS_PAGE_SIZE', count);
                            }
                            data.data.forEach(item => {
                                item.status = item.status == 1;
                            });
                            this.data = data.data || [];
                            this.pagination.total = parseInt(data.total);
                            this.pagination.index = current;
                        } else {
                            console.log(data);
                            this.$message(message ? message : this.$t('请求失败'), 'error');
                        }
                        document.documentElement.scrollTop = 0;
                    },
                    error => {
                        console.log(error);
                        this.$message(error || this.$t('请求出错'), 'error');
                    }
                );
        },
        getCorpFeatureStatus() {
            this.loading = true;
            this.$ajax
                .gatewayGet('/tp/sensitiveWords/getCorpFeatureStatus').then(
                data => {
                    this.globalSwitch = data.data == 1;
                    this.firstLoading = false;
                    if (data.data == 1) {
                        this.paginationChange();
                    } else {
                        this.loading = false;
                    }
                },
                error => {
                    console.log(error);
                    this.$message(error || this.$t('请求出错'), 'error');
                }
            );
        },
        setCorpFeatureStatus() {
            const newStatus = !this.globalSwitch;
            this.loading = true;
            this.$ajax
                .gatewayPost('/tp/sensitiveWords/setCorpFeatureStatus', {
                    status: newStatus ? 1 : 0
                })
                .then(
                    data => {
                        const { message = '' } = data;
                        if (data.r == 0) {
                            if (newStatus) {
                                // 开启成功，请求是否有历史数据
                                this.paginationChange();
                            } else {
                                // 关闭成功，清除本地规则数据
                                this.data = [];
                                this.loading = false;
                            }
                            this.$message(newStatus ? this.$t('开启成功') : this.$t('关闭成功'), 'success');
                        } else {
                            // 操作失败，恢复状态
                            this.$nextTick(function() {
                                this.globalSwitch = !newStatus;
                            });
                            this.loading = false;
                            this.$message(message ? message : (newStatus ? this.$t('开启失败') : this.$t('关闭失败')), 'error');
                        }
                    },
                    error => {
                        console.log(error);
                        this.$message(error || this.$t('请求出错'), 'error');
                    }
                );
        },
        itemStatusChange(newStatus, value) {
            this.pageLoading = true;
            let postData = {
                    id: value.id,
                    name: value.name,
                    actionType: value.actionType,
                    channelIds: value.channelIds,
                    wordList: value.wordList,
                    monitoredOrgIds: value.monitoredOrgIds,
                    monitoredUins: value.monitoredUins,
                    status: newStatus ? 1 : 0
            }
            // 新增side 参数 1 为员工敏感词 2 为客户敏感词
            if(this.clientSideFlag === 1) {
                postData.side = this.tabValue === 'client' ? 2 : 1;
            }
            this.$ajax
                .gatewayPost('/tp/sensitiveWords/update', postData)
                .then(
                    data => {
                        const { message = '' } = data;
                        this.pageLoading = false;
                        if (data.r == 0) {
                            this.$message(newStatus ? this.$t('开启成功') : this.$t('关闭成功'), 'success');
                        } else {
                            value.status = !newStatus;
                            this.$message(message ? message : (newStatus ? this.$t('开启失败') : this.$t('关闭失败')), 'error');
                        }
                    },
                    error => {
                        console.log(error);
                        this.pageLoading = false;
                        value.status = !newStatus;
                        this.$message(error || this.$t('请求出错'), 'error');
                    }
                );
        },
        tabChange() {
            // 切换的时候需要重新拉取状态
            if(this.tabValue !== 'monitorRecords'){
                this.getCorpFeatureStatus();
                this.refreshRuleList();
            }
            if(this.tabValue === 'sensitiveManage'){
                this.currentSensitiveWords = '';
            }
            console.log(this.tabValue,"tabValue改变");
            //
            let linkUrl = utils.setUrlParam(window.location.href,'currentTab',this.tabValue)
            window.history.pushState('', '', linkUrl);
        },
        refreshRuleList() {
            this.ruleListKeys = `ru_${Date.now()}`
        },
        onTagClickHandler(item){
            this.currentSensitiveWords = item;
            this.tabValue = 'monitorRecords';
        }
    }
};
</script>

<style lang="less">
@import './styles/app';
</style>
